import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Bell, BellOff, TestTube } from "lucide-react";
import { Button } from "@/components/ui/button";
import { isPushSupported, getCurrentSubscription, subscribePush, unsubscribePush, testPush } from "@/lib/push";

export default function PushToggle() {
  const [subscribed, setSubscribed] = useState(false);
  const [loading, setLoading] = useState(false);
  const supported = isPushSupported();

  useEffect(() => {
    if (!supported) return;
    getCurrentSubscription().then((s) => setSubscribed(!!s));
  }, [supported]);

  if (!supported) return null;

  const enable = async () => {
    setLoading(true);
    try { await subscribePush(); setSubscribed(true); toast.success("Notificacions activades"); }
    catch (e) { toast.error(e.message || "Error activant"); }
    finally { setLoading(false); }
  };
  const disable = async () => {
    setLoading(true);
    try { await unsubscribePush(); setSubscribed(false); toast.success("Notificacions desactivades"); }
    finally { setLoading(false); }
  };
  const test = async () => {
    try { const { data } = await import("@/lib/push").then(m => m.testPush()) || {};
      toast.success("Push de prova enviat");
    } catch { toast.error("Error"); }
  };

  return (
    <div className="flex items-center gap-2">
      {subscribed ? (
        <>
          <Button variant="outline" size="sm" onClick={disable} disabled={loading} className="rounded-full" data-testid="push-disable-btn">
            <BellOff className="w-4 h-4 mr-2" /> Desactivar avisos
          </Button>
          <Button variant="ghost" size="sm" onClick={async () => { try { await testPush(); toast.success("Push de prova enviat"); } catch { toast.error("Error"); } }} disabled={loading} className="rounded-full" data-testid="push-test-btn">
            <TestTube className="w-4 h-4 mr-2" /> Prova
          </Button>
        </>
      ) : (
        <Button size="sm" onClick={enable} disabled={loading} className="rounded-full" data-testid="push-enable-btn">
          <Bell className="w-4 h-4 mr-2" /> Activar notificacions push
        </Button>
      )}
    </div>
  );
}
